export class PrelevementIBD {

    constructor(n?: number) {
        this.Numero = n;
    }
    Numero: number;
    DistanceBerge: number;
    Profondeur: number;

    static mapFromJSON(json): PrelevementIBD {
        const p = new PrelevementIBD();

        p.Numero = json.numero;
        p.DistanceBerge = json.distanceBerge;
        p.Profondeur = json.profondeur;

        return p;
    }
}
